import * as React from 'react';
import Markdown from 'react-markdown';
import { Typography } from '@one-thd/sui-atomic-components';
import { Prose } from '@one-thd/sui-prose';

const RenderMarkdown = ({ markdownText }) => (
  <Markdown>
    {markdownText}
  </Markdown>
);

export const SweepstakesMarkdown = ({ markdownText }) => {
  return (
    <Prose>
      <div
        className="sui-text-sm"
        style={{
          '--marker-color': '#000'
        }}
      >
        {/* Overrides list number/bullet grey color to black */}
        <style>
          {`
            .sui-text-sm ol li::marker,
            .sui-text-sm ul li::marker {
              color: var(--marker-color) !important;
            }
          `}
        </style>
        <RenderMarkdown markdownText={markdownText} />
      </div>
    </Prose>
  );
};